import { v4 } from "uuid";

import type { ICol } from "../../../interfaces";
/**
 * Replaces exclusive values in a row with unique identifiers.
 *
 * @param row - A record containing columns (`ICol`) where exclusive values need to be replaced.
 * @returns A new row object with updated exclusive values.
 */
export const replaceExclusiveValues = (row: Record<string, ICol>) => {
  const updatedData = { ...row };

  let sharedExlusives: Record<string, any> = {};
  let sharedExclusiveUsers: Record<string, any> = {};

  for (const objKey in updatedData) {
    const obj = updatedData[objKey];

    if (obj.exclusive && obj.exclusive in sharedExlusives) {
      obj.exclusive = sharedExlusives[obj.exclusive];
    } else if (obj.exclusive) {
      const newId = v4();
      sharedExlusives = { ...sharedExlusives, [obj.exclusive]: newId };
      obj.exclusive = newId;
    }

    if (obj.exclusiveUser && obj.exclusiveUser in sharedExclusiveUsers) {
      obj.exclusiveUser = sharedExclusiveUsers[obj.exclusiveUser];
    } else if (obj.exclusiveUser) {
      const newId = v4();
      sharedExclusiveUsers = {
        ...sharedExclusiveUsers,
        [obj.exclusiveUser]: newId,
      };
      obj.exclusiveUser = newId;
    }
  }

  return updatedData;
};
